<script setup lang="ts">
import TaxiOfferCard from '../TaxiOfferCard.vue';
// eslint-disable-next-line no-restricted-imports
import PriceActions from '../../price-actions/PriceActions.vue';
import CardSection from '@components/ui/hotel&view/card-section/sections/CardSection.vue';
import TripCard from '@components/ui/hotelPage&view/cards/trip/TripCard.vue';
import type TripPackage from '@itinerary/trip/TripPackage';

const {
    list = [],
    title,
    displayPriceTrack,
    displayTaxiOffer,
} = defineProps<IProps>();
const emit = defineEmits<{
    buttonClicked: [item: TripPackage, index: number];
    viewSection: [];
}>();
interface IProps {
    title?: string;
    list?: TripPackage[];
    displayBanners?: boolean;
    displayPriceTrack?: boolean;
    displayTaxiOffer?: boolean;
    realTimeLoading?: boolean;
}
const currentShowDetailsIndex = ref<number>();
const priceTrackIndex = computed(() =>
    list.length >= 3 ? 2 : list.length < 3 ? list.length - 1 : 0
);
watch(
    () => list,
    () => {
        currentShowDetailsIndex.value = undefined;
    }
);
</script>

<template>
    <CardSection
        :title
        :display-banners
        :list
        :real-time-loading
        @view-section="emit('viewSection')"
    >
        <template #card="{ item, index, mouseenter, mouseleave }">
            <TripCard
                :trip-package="item"
                :is-open-details="currentShowDetailsIndex === index"
                @button-clicked="emit('buttonClicked', $event, index)"
                @show-details="() => (currentShowDetailsIndex = index)"
                @hide-details="() => (currentShowDetailsIndex = undefined)"
                @mouseenter="mouseenter"
                @mouseleave="mouseleave"
            />
        </template>
        <template #extra-item>
            <slot name="extra-item" />
            <PriceActions
                v-if="displayPriceTrack"
                key="forecastTrack"
                :style="{ order: priceTrackIndex }"
                mobile-only
            />
            <TaxiOfferCard v-if="displayTaxiOffer" key="taxi-offer-card" />
        </template>
    </CardSection>
</template>
